module.exports = __webpack_public_path__ + "img/81fa143.png";